import Icon from "@ant-design/icons";

const Svg = () => {
  return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M12 7.55556V12H14.6667M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
              stroke="#6A6A6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;